import { Avatar, Collapse, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import Button from "../Button/Button";
import { Menu, Close } from "@material-ui/icons";
import { blue900, darkBlue, lightGray, white } from "../constants";
import { AVAILABLE_ROUTES } from "../Sidebar/Sidebar";
import NavItem from "../Sidebar/NavItem";
import { useDispatch } from "react-redux";
import { useTranslation } from "../../../../hooks/useTranslation";
import { logout } from "../../../../redux/actions/authActions";
import DialogConfirmation from "../Dialog/DialogConfirmation";

const useHeaderMobileStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  root: {
    backgroundColor: "white",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "full-content",
    justifyContent: "space-between",
    borderBottom: "1px solid #E5E7EB",
    paddingInline: "32px",
    paddingBlock: "12px",
    zIndex: 10,
  },
  left: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "8px",
  },
  menuButton: {
    width: "fit-content",
    paddingBlock: 12,
    paddingInline: 0,
    border: "none",
    "& .MuiButton-label": {
      paddingInline: 0,
    },
    minWidth: "auto",
  },
  locationContainer: {
    backgroundColor: "white",
    padding: "16px 12px",
    borderBottom: "1px solid #E5E7EB",
  },
  locationTitle: {
    fontSize: 12,
    fontWeight: 600,
    color: lightGray,
  },
  locationDescription: {
    fontSize: 14,
    fontWeight: "bold",
    color: darkBlue,
  },
  navContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    paddingBlock: 12,
  },
  collapsedContainer: {
    backgroundColor: white,
    paddingInline: 24,
  },
}));

const HeaderMobile = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [openLogoutDialog, setOpenLogoutDialog] = React.useState(false);
  const classes = useHeaderMobileStyles();
  const dispatch = useDispatch();
  const { t, BundleKey } = useTranslation();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleConfirmLogout = () => {
    dispatch(logout());
    setOpenLogoutDialog(false);
  };

  return (
    <div className={classes.container}>
      <div className={classes.root}>
        <div className={classes.left}>
          <Button variant="outline" className={classes.menuButton} onClick={toggleMenu}>
            {isOpen ? <Close /> : <Menu />}
          </Button>
          <img src="/logo.svg" alt="Logo" />
        </div>
        <Avatar style={{ backgroundColor: blue900 }}>JP</Avatar>
      </div>
      <Collapse className={classes.collapsedContainer} in={isOpen}>
        <div className={classes.locationContainer}>
          <Typography className={classes.locationTitle}>UBICACIÓN ACTUAL</Typography>
          <Typography className={classes.locationDescription}>Portón Norte - Recinto A</Typography>
        </div>
        <div className={classes.navContainer}>
          {AVAILABLE_ROUTES?.map((ar) => {
            if (ar.isLogout) {
              return (
                <NavItem
                  key={ar.label}
                  collapsed={false}
                  icon={ar.icon}
                  label={t(BundleKey.LOGOUT_TITLE)}
                  onClick={() => setOpenLogoutDialog(true)}
                />
              );
            }
            return <NavItem key={ar.href} collapsed={false} {...ar} />;
          })}
        </div>
      </Collapse>
      <DialogConfirmation
        open={openLogoutDialog}
        onClose={() => setOpenLogoutDialog(false)}
        onConfirm={handleConfirmLogout}
        title={t(BundleKey.LOGOUT_TITLE)}
        message={t(BundleKey.LOGOUT_MESSAGE)}
        confirmLabel={t(BundleKey.ACTION_YES)}
        cancelLabel={t(BundleKey.ACTION_NO)}
      />
    </div>
  );
};

export default HeaderMobile;
